import React, { Component } from 'react';
import './App.scss';
import List from './List';
import Wish from './Wish';
import Home from './Home';
import ThankYou from './ThankYou';
import DatenSchutzPage from './Pages/DatenSchutzPage';
import ContactUsPage from './Pages/ContactUsPage';
import HowToDonatePage from './Pages/HowToDonatePage';
import Impressum from './Pages/Impressum';
import Jumbotron from '../Component/Jumbotron';
import { connect } from 'react-redux';
import { fetchChildrenList } from '../Actions/ChildrenList';
import { Route, Switch, Router, Link } from 'react-router-dom';
import history from '../History';
import Logo from '../Assets/logo.svg';
import ScrollToTop from '../Component/ScrollToTop';
import BottomNav from './HomeElements/BottomNav';
import Navigation from '../Component/Navigation';
import Notification from '../Component/Notification';
import { toggleNavbar } from '../Actions/Navigation';
import { fetchSponsorsList } from '../Actions/SponsorsList';

class App extends Component {
  componentDidMount() {
    this.props.fetchChildrenList();
    this.props.fetchSponsorsList();
  }

  render() {
    return (
      <Router history={history}>
        <ScrollToTop>
          <Notification />
          <div className="topbg">
            <nav className="navbar navbar-default">
              <div className="container">
                <div className="navbar-header">
                  <button
                    type="button"
                    onClick={this.props.toggleNavbar}
                    className="navbar-toggle collapsed"
                    aria-expanded="false"
                  >
                    <span className="sr-only">Toggle navigation</span>
                    <span className="icon-bar" />
                    <span className="icon-bar" />
                    <span className="icon-bar" />
                  </button>
                  <Link className="navbar-left" to={'/'}>
                    <img alt="Luther Kirche Logo" src={Logo} />
                  </Link>
                </div>
                <Navigation />
              </div>
            </nav>
            <Switch>
              <Route exact path="/" component={Jumbotron} />
            </Switch>
          </div>
          <div className="container main-container">
            <Switch>
              <Route exact path="/" component={Home} />
              <Route path="/list/:page?" component={List} />
              <Route path="/wish/:id" component={Wish} />
              <Route path="/impressum" component={Impressum} />
              <Route path="/thankyou" component={ThankYou} />
              <Route path="/dataprotection" component={DatenSchutzPage} />
              <Route path="/contact" component={ContactUsPage} />
              <Route path="/howto" component={HowToDonatePage} />
            </Switch>
          </div>
          <BottomNav />
        </ScrollToTop>
      </Router>
    );
  }
}

const mapStateToProps = state => {
  return {};
};

const mapDispatchToProps = dispatch => {
  return {
    fetchSponsorsList: () => dispatch(fetchSponsorsList()),
    fetchChildrenList: () => dispatch(fetchChildrenList()),
    toggleNavbar: () => dispatch(toggleNavbar())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);



// WEBPACK FOOTER //
// ./src/Containers/App.js